import {gql} from "graphql-request";

export const GetLiveLocatorSessionByObfuscatedId = gql`
  query GetLiveLocatorSessionByObfuscatedId($obfuscatedId:String!) {
    liveLocatorSessionByObfuscatedId(obfuscatedId:$obfuscatedId) {
      id
      durationMinutes
      obfuscatedId
      user {
        displayName
        title
        avatar {
          lgUrl
        }
      }
      createdAt
      platform
      elevationGainMeters
      distanceMeters
      colour
      currentLonlat
      startAddress {
        id
      }
      endAddress {
        id
      }
      colour
      currentLonlat
      recordingClientId
      endTime
    }
  }
`;
